import { Component, HostListener, OnInit } from '@angular/core';
import { differenceInCalendarDays } from 'date-fns';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { FilesService } from '../../../core/services/files.service';
import { SupplierService } from '../../../core/services/supplier.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { AgentService } from '../../../core/services/agent.service';
import { FleetService } from '../../../core/services/fleet.service';
import { CustomerService } from '../../../core/services/customer.service';
import { DriverService } from '../../../core/services/driver.service';
import { TransferReservationService } from '../../../core/services/transfer-reservation.service';
import { IDeactivateComponent } from '../../../core/guards/deactivate.gaurd';
import { Observable } from 'rxjs';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { CurrencyService } from '../../../core/services/currency.service';
import { EmailContentDrawerComponent } from '../../shared/email-content-drawer/email-content-drawer.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { SETTINGS } from '../../../core/config/common.settings';
import { AppUtils } from '../../../core/config/app.utils';

const ADD_EDIT_TRANSFER_BOOKING_COST_INFO_UPLOAD =
  'ADD_EDIT_TRANSFER_BOOKING_COST_INFO_UPLOAD';

@Component({
  selector: 'app-add-edit-booking',
  templateUrl: './add-edit-booking.component.html',
  styleUrls: ['./add-edit-booking.component.scss'],
})
export class AddEditBookingComponent implements OnInit, IDeactivateComponent {
  transferForm: FormGroup | any;
  breadcrumbs: any[] = [];
  extraChargesCurrencies: any[] = [];
  formErrors: any;
  selectedSupplierId: any;
  departureCheckBox = true;
  visibleAddAgentPopup = false;
  visibleAddCustomerPopup = false;
  visibleAddVehiclePopup = false;
  visibleAddDriverPopup = false;
  chargesOptions: any[] = [
    'Location Change Charge',
    'Extra millage and waiting charges',
    'Baby seat charge',
    'Route change charge',
    'Other ',
  ];
  index = 0;
  dIndex = 0;
  currencyOptions: any[] = [
    { value: 'USD', label: '$' },
    { value: 'EUR', label: '€' },
    { value: 'GBP', label: '£' },
    { value: 'CNY', label: '¥' },
    { value: 'LKR', label: 'Rs' },
  ];
  departureSupplier = '';
  arrivalSupplier = '';
  driverOptions: any[] = [];
  driverOptionsDep: any[] = [];
  driverOptionsFiltered: any[] = [];
  driverOptionsDepFiltered: any[] = [];
  supplierVehicleOptionsArrival: any[] = [];
  supplierVehicleOptionsDeparture: any[] = [];
  supplierVehicleOptionsArrivalFiltered: any[] = [];
  supplierVehicleOptionsDepartureFiltered: any[] = [];
  agentOptions: any[] = [];
  agentOptionsFiler: any[] = [];
  customerOptions: any[] = [];
  customerOptionsFilter: any[] = [];
  fleetsOptions: any[] = [];
  fleetsOptionsFiltered: any[] = [];
  fleetsOptionsDeparture: any[] = [];
  fleetsOptionsDepartureFiltered: any[] = [];
  vehicleCategories: any;
  vehicleCategoriesArrivalFiltered: any;
  vehicleCategoriesDepFiltered: any;
  bookingCostInfoUploadFiles: any[] = [];
  reservationId: any;
  prevPage: any;
  bookingData: any;
  submit = false;
  loading = false;
  totalExtraChargesInLKR = 0;
  totalDeductionsInLKR = 0;
  deductionOptions: any[] = ['Vehicle Breakdown'];
  deductionCurrencies: any[] = [];
  arrivalVehicle = {
    image: 'assets/img/image-placeholder.png',
    registrationNo: '-',
    mileage: 0,
    fuel: 0,
    seats: 0,
    model: '',
  };
  depVehicle = {
    image: 'assets/img/image-placeholder.png',
    registrationNo: '-',
    mileage: 0,
    fuel: 0,
    seats: 0,
    model: '',
  };
  arrivalDriver = {
    name: '-',
    mobileNo: '-',
    supplier: '-',
  };
  depDriver = {
    name: '-',
    mobileNo: '-',
    supplier: '-',
  };
  fleetsFetching = false;
  driversFetching = false;
  supplierVehiclesFetching = false;
  fleetsFetchingDep = false;
  driversFetchingDep = false;
  supplierVehiclesFetchingDep = false;
  totalPassengers = 0;
  totalPassengersDep = 0;
  defaultLKR: any;
  tempBookingId: any;
  tempBooking: any;
  emailContent = '';
  availabilityStatusPairs = SETTINGS.AVAILABILITY_STATUS_PAIRS;
  driverAvailabilityStatus = SETTINGS.DRIVER_AVAILABILITY_STATUS;
  // formatterDistance = (value: number): string => `${value} KM`;
  // parserDistance = (value: string): string => value.replace(' KM', '');
  // formatterPercentFuel = (value: number): string => `${value} LKR`;
  // parserPercentFuel = (value: string): string => value.replace(' LKR', '');

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): string | undefined {
    const confirmationMessage =
      'You have unsaved changes. Do you really want to leave?';
    $event.returnValue = confirmationMessage; // Standard for most browsers
    return confirmationMessage; // For some older browsers
  }

  constructor(
    private fb: FormBuilder,
    private filesService: FilesService,
    private router: Router,
    private route: ActivatedRoute,
    private message: NzMessageService,
    private agentService: AgentService,
    private fleetService: FleetService,
    private customerService: CustomerService,
    private driverService: DriverService,
    private transferService: TransferReservationService,
    private currencyService: CurrencyService,
    private supplierService: SupplierService,
    private drawerService: NzDrawerService,
  ) {}

  ngOnInit(): void {
    this.initTransferForm();
    this.setBreadcrumbs();
    this.getAgentOptions();
    this.getDriverOptions();
    this.getDriverOptionsDep();
    this.getCustomerOptions();
    this.getVehicleCategory();
    this.getCurrencyOptions();

    this.route.queryParams.subscribe((params) => {
      this.prevPage = params['prev'];
      this.tempBookingId = params['tempBookingId'];
    });
    this.reservationId = this.route.snapshot.paramMap.get('id');

    if (this.tempBookingId) {
      this.getAndSetTempBooking();
    }

    if (this.reservationId) {
      this.loading = true;
      this.transferService
        .getTransferBookingById(this.reservationId)
        .then((res) => {
          this.bookingData = res;
          this.emailContent = this.bookingData?.emailContentId?.content
            ? this.bookingData?.emailContentId?.content
            : '';

          this.transferForm.patchValue(this.bookingData);
          if (this.bookingData?.arrivalDetails?.arrivalSupplier) {
            this.arrivalSupplier =
              this.bookingData?.arrivalDetails?.arrivalSupplier;
          } else if (this.bookingData?.departureDetails?.departureSupplier) {
            this.departureSupplier =
              this.bookingData?.departureDetails?.departureSupplier;
          }
          if (
            this.bookingData?.arrivalDetails.status === 'ON_TRANSFER' ||
            this.bookingData?.arrivalDetails.status === 'COMPLETED' ||
            this.bookingData?.departureDetails.status === 'ON_TRANSFER' ||
            this.bookingData?.departureDetails.status === 'COMPLETED'
          ) {
            this.transferForm.get('bookingDetails').disable();
            this.transferForm.get('tourDetails.customer').disable();
          }

          if (this.bookingData.departureDetails.status === 'COMPLETED') {
            this.transferForm.get('departureDetails').disable();
            this.transferForm.get('tourDetails.departureTourDetails').disable();
          }

          if (this.bookingData.arrivalDetails.status === 'COMPLETED') {
            this.transferForm.get('arrivalDetails').disable();
            this.transferForm.get('tourDetails.arrivalFlightNumber').disable();
            this.transferForm.get('tourDetails.arrivalFlightTime').disable();
            this.transferForm.get('tourDetails.arrivalFlightDate').disable();
            this.transferForm.get('tourDetails.pickUpTime').disable();
            this.transferForm.get('tourDetails.pickUpLocation').disable();
            this.transferForm.get('tourDetails.dropOffLocation').disable();
            this.transferForm.get('tourDetails.dropOffCity').disable();
            this.transferForm.get('tourDetails.noOfPassengers').disable();
            this.transferForm.get('tourDetails.noOfAdults').disable();
            this.transferForm.get('tourDetails.noOfChildren').disable();
            this.transferForm.get('tourDetails.noOfInfants').disable();
            this.transferForm.get('tourDetails.noOfLuggages').disable();
            this.transferForm.get('tourDetails.vehicleCategory').disable();
            this.transferForm
              .get('tourDetails.distanceToDestination')
              .disable();
            this.transferForm.get('tourDetails.departureCheck').disable();
          }

          if (this.bookingData?.arrivalDetails?.allocatedVehicle?._id) {
            this.getFleetVehicle(
              this.bookingData?.arrivalDetails?.allocatedVehicle._id,
            );
            this.arrivalVehicle.registrationNo =
              this.bookingData.arrivalDetails?.allocatedVehicle?.vehicleDetails
                ?.registrationNumber;
            if (this.bookingData.arrivalDetails?.startMileage) {
              this.arrivalVehicle.mileage =
                this.bookingData.arrivalDetails?.startMileage;
              this.arrivalVehicle.fuel =
                this.bookingData.arrivalDetails?.startFuel;
            }
          } else if (this.bookingData?.arrivalDetails?.allocateVehicle) {
            this.getSupplierVehiclesArrival(
              this.bookingData?.arrivalDetails?.allocateDriver._id,
            );
          }

          if (this.bookingData?.departureDetails?.allocatedVehicle?._id) {
            this.getFleetVehicle(
              this.bookingData?.departureDetails?.allocatedVehicle._id,
            );
            this.depVehicle.registrationNo =
              this.bookingData.departureDetails?.allocatedVehicle
                ?.vehicleDetails?.registrationNumber;
            if (this.bookingData.departureDetails?.startMileage) {
              this.depVehicle.mileage =
                this.bookingData.departureDetails?.startMileage;
              this.depVehicle.fuel =
                this.bookingData.departureDetails?.startFuel;
            }
          } else if (this.bookingData?.departureDetails?.allocateVehicle) {
            this.getSupplierVehiclesDeparture(
              this.bookingData?.departureDetails?.allocateDriver._id,
            );
          }

          if (this.bookingData?.arrivalDetails?.allocateDriver?._id) {
            this.getDriver(
              this.bookingData?.arrivalDetails?.allocateDriver?._id,
            );
          }
          if (this.bookingData?.departureDetails?.allocateDriver?._id) {
            this.getDriverDep(
              this.bookingData?.departureDetails?.allocateDriver?._id,
            );
          }

          if (
            this.bookingData.bookingDetails?.bookingCategory === 'Arrival' &&
            this.bookingData.tourDetails?.departureCheck !== true
          ) {
            this.getVehicles(this.bookingData.tourDetails?.vehicleCategory);
            this.getSupplierVehiclesArrival(
              this.bookingData?.arrivalDetails?.allocateDriver?._id,
            );
            this.getVehiclesDeparture(
              this.bookingData.tourDetails?.departureTourDetails
                ?.departureVehicleCategory,
            );
          } else if (
            this.bookingData?.bookingDetails?.bookingCategory === 'Departure'
          ) {
            this.getVehiclesDeparture(
              this.bookingData.tourDetails?.departureTourDetails
                ?.departureVehicleCategory,
            );
            this.getSupplierVehiclesDeparture(
              this.bookingData.departureDetails?.allocateDriver?._id,
            );
            this.getSupplierVehicleDep(
              this.bookingData?.departureDetails?.allocateVehicle,
            );
          } else {
            this.getVehicles(this.bookingData?.tourDetails?.vehicleCategory);
            this.getVehiclesDeparture(
              this.bookingData?.tourDetails?.departureTourDetails
                ?.departureVehicleCategory,
            );
            this.getSupplierVehiclesArrival(
              this.bookingData?.arrivalDetails?.allocateDriver?._id,
            );
            this.getSupplierVehicle(
              this.bookingData?.arrivalDetails?.allocateVehicle,
            );
            this.getSupplierVehiclesDeparture(
              this.bookingData?.departureDetails?.allocateDriver?._id,
            );
            this.getSupplierVehicleDep(
              this.bookingData?.departureDetails?.allocateVehicle,
            );
          }

          // this.transferForm.patchValue(this.bookingData);
          this.transferForm.patchValue({
            arrivalDetails: {
              allocatedVehicle:
                this.bookingData?.arrivalDetails?.allocatedVehicle?._id || null,
            },
          });
          this.transferForm.patchValue({
            bookingDetails: {
              agent: this.bookingData?.bookingDetails?.agent?._id || null,
            },
          });
          this.transferForm.patchValue({
            arrivalDetails: {
              allocateDriver:
                this.bookingData?.arrivalDetails?.allocateDriver?._id,
            },
          });
          this.transferForm.patchValue({
            arrivalDetails: {
              allocateVehicle:
                this.bookingData?.arrivalDetails?.allocateVehicle || null,
            },
          });
          this.transferForm.patchValue({
            departureDetails: {
              allocatedVehicle:
                this.bookingData?.departureDetails?.allocatedVehicle?._id ||
                null,
            },
          });
          this.transferForm.patchValue({
            departureDetails: {
              allocateDriver:
                this.bookingData?.departureDetails?.allocateDriver?._id,
            },
          });
          this.transferForm.patchValue({
            departureDetails: {
              allocateVehicle:
                this.bookingData?.departureDetails?.allocateVehicle || null,
            },
          });
          this.transferForm
            .get('tourDetails.customer')
            .patchValue(this.bookingData.tourDetails?.customer?._id);

          if (this.bookingData?.bookingCost?.extraCharges?.length > 0) {
            this.transferForm.get('bookingCost').get('extraCharges').clear();
            this.bookingData?.bookingCost?.extraCharges?.forEach((xc: any) => {
              (
                this.transferForm
                  .get('bookingCost')
                  .get('extraCharges') as FormArray
              ).push(this.createAExtraCharges());
              if (!this.chargesOptions.includes(xc.chargeType)) {
                this.addItem({ value: xc.chargeType });
              }
            });

            this.transferForm.patchValue({
              bookingCost: {
                extraCharges: this.bookingData?.bookingCost?.extraCharges,
              },
            });
          }
          this.setBreadcrumbs();
          this.loading = false;
        });
    } else {
      this.setBreadcrumbs();
    }
  }

  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, new Date()) < 0;

  initTransferForm(): void {
    this.transferForm = this.fb.group({
      bookingDetails: this.fb.group({
        bookingReceivedDate: [null, [Validators.required]],
        bookingType: [null, [Validators.required]],
        agent: [null],
        bookingReference: [null],
        bookingCategory: [null, [Validators.required]],
      }),

      tourDetails: this.fb.group({
        customer: [null, [Validators.required]],
        arrivalFlightNumber: [null, [Validators.maxLength(30)]],
        arrivalFlightTime: [null],
        arrivalFlightDate: [null],
        arrivalDateAndTime: [null, []],
        pickUpTime: [null],
        arrivalEndDate: [null],
        arrivalEndTime: [null],
        pickUpLocation: [null],
        dropOffLocation: [null],
        dropOffCity: [null],
        noOfPassengers: [{ value: null, disabled: true }],
        noOfAdults: [null],
        noOfChildren: [null],
        noOfInfants: [null],
        noOfLuggages: [null],
        vehicleCategory: [null],
        distanceToDestination: [0],
        departureCheck: [false],
        departureTourDetails: this.fb.group({
          departureFlightNumber: [null, [Validators.maxLength(30)]],
          departureFlightTime: [null],
          departureFlightDate: [null],
          departureEndDate: [null],
          departureEndTime: [null],
          departurePickUpTime: [null],
          departureDateAndTime: [null, []],
          departurePickUpLocation: [null],
          departureDropOffLocation: [null],
          departureDropOffCity: [null],
          departureNoOfPassengers: [{ value: null, disabled: true }],
          departureNoOfAdults: [null],
          departureNoOfChildren: [null],
          departureNoOfInfants: [null],
          departureNoOfLuggages: [null],
          departureVehicleCategory: [null],
          departureDistanceToDestination: [0],
        }),
      }),
      arrivalDetails: this.fb.group({
        allocatedVehicle: [null],
        driverCategory: [null],
        allocateDriver: [null],
        allocateVehicle: [null],
        outsourcedRate: [null],
        outsourcedRateCurrency: ['65961e65cad7ae7c000623ff', []],
        outsourcedRateCurrencyDetails: [null, []],
        arrivalSupplier: [null],
        status: ['NONE'],
      }),
      departureDetails: this.fb.group({
        allocatedVehicle: [null],
        driverCategory: [null],
        allocateDriver: [null],
        allocateVehicle: [null],
        outsourcedRate: [null],
        outsourcedRateCurrency: [null, []],
        outsourcedRateCurrencyDetails: [null, []],
        departureSupplier: [null],
        status: ['NONE'],
      }),
      bookingCost: this.fb.group({
        transferCost: [null, [Validators.required]],
        transferCurrency: ['65961e65cad7ae7c000623ff', []],
        transferCurrencyDetails: [null, []],
        extraCharges: this.fb.array([]),
      }),
      otherInformation: this.fb.group({
        specialInstructions: [null],
        userComments: [null],
      }),
    });

    this.fleetOptionChangeOnDateChange();

    // Arrival No of passengers counting
    this.transferForm
      .get('tourDetails.noOfAdults')
      .valueChanges.subscribe(() => this.calculateTotalPassengers());
    this.transferForm
      .get('tourDetails.noOfChildren')
      .valueChanges.subscribe(() => this.calculateTotalPassengers());
    this.transferForm
      .get('tourDetails.noOfInfants')
      .valueChanges.subscribe(() => this.calculateTotalPassengers());
    // Departure No of passengers counting
    this.transferForm
      .get('tourDetails.departureTourDetails.departureNoOfAdults')
      .valueChanges.subscribe(() => this.calculateTotalPassengersDep());
    this.transferForm
      .get('tourDetails.departureTourDetails.departureNoOfChildren')
      .valueChanges.subscribe(() => this.calculateTotalPassengersDep());
    this.transferForm
      .get('tourDetails.departureTourDetails.departureNoOfInfants')
      .valueChanges.subscribe(() => this.calculateTotalPassengersDep());

    this.transferForm
      .get('tourDetails')
      .valueChanges.subscribe((values: any) => {
        if (
          values.arrivalFlightDate ||
          values.pickUpTime ||
          values.arrivalEndDate ||
          values.arrivalEndDate
        ) {
          this.getDriverOptions(
            this.transferForm.get('arrivalDetails.driverCategory').value,
          );
        }
        if (
          values.departureTourDetails.departureFlightDate ||
          values.departureTourDetails.departurePickUpTime ||
          values.departureTourDetails.departureEndDate ||
          values.departureTourDetails.departureEndTime
        ) {
          this.getDriverOptionsDep(
            this.transferForm.get('departureDetails.driverCategory').value,
          );
        }
      });

    this.transferForm
      .get('tourDetails')
      .valueChanges.subscribe((values: any) => {
        if (values.arrivalFlightDate && values.pickUpTime) {
          let arrivalDateAndTime = new Date(values.arrivalFlightDate);
          const arrivalTime = new Date(values.pickUpTime);
          arrivalDateAndTime = new Date(
            arrivalDateAndTime.setHours(arrivalTime.getHours()),
          );
          arrivalDateAndTime = new Date(
            arrivalDateAndTime.setMinutes(arrivalTime.getMinutes()),
          );
          arrivalDateAndTime = new Date(
            arrivalDateAndTime.setSeconds(arrivalTime.getSeconds()),
          );

          this.transferForm
            .get('tourDetails')
            .get('arrivalDateAndTime')
            .setValue(arrivalDateAndTime, {
              onlySelf: true,
              emitEvent: false,
            });
          this.transferForm
            .get('tourDetails')
            .get('arrivalDateAndTime')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        }
      });

    this.transferForm
      .get('tourDetails')
      .get('departureTourDetails')
      .valueChanges.subscribe((values: any) => {
        if (values.departureFlightDate && values.departurePickUpTime) {
          let departureDateAndTime = new Date(values.departureFlightDate);
          const departureTime = new Date(values.departurePickUpTime);
          departureDateAndTime = new Date(
            departureDateAndTime.setHours(departureTime.getHours()),
          );
          departureDateAndTime = new Date(
            departureDateAndTime.setMinutes(departureTime.getMinutes()),
          );
          departureDateAndTime = new Date(
            departureDateAndTime.setSeconds(departureTime.getSeconds()),
          );

          this.transferForm
            .get('tourDetails')
            .get('departureTourDetails')
            .get('departureDateAndTime')
            .setValue(departureDateAndTime, {
              onlySelf: true,
              emitEvent: false,
            });
          this.transferForm
            .get('tourDetails')
            .get('departureTourDetails')
            .get('departureDateAndTime')
            .updateValueAndValidity({
              onlySelf: true,
              emitEvent: false,
            });
        }
      });

    this.transferForm.valueChanges.subscribe((values: any) => {
      const temp = this.transferForm.get('bookingCost.extraCharges').value;
      if (temp.length > 0) {
        this.totalExtraChargesInLKR = 0;
        temp.forEach((ec: any) => {
          if (ec.currency) {
            const cu = this.currencyOptions?.find(
              (cu: any) => cu._id === ec.currency,
            );
            ec.currencyDetails = cu;
            if (ec.amount) {
              this.totalExtraChargesInLKR =
                this.totalExtraChargesInLKR + cu?.lkrRate * ec.amount;
            }

            if (values?.bookingCost?.extraCharges?.length > 0) {
              this.totalExtraChargesInLKR = 0;
              values?.bookingCost?.extraCharges?.forEach((ec: any) => {
                if (ec.currency) {
                  const cu = this.currencyOptions?.find(
                    (cu: any) => cu._id === ec.currency,
                  );

                  if (ec.amount) {
                    this.totalExtraChargesInLKR =
                      this.totalExtraChargesInLKR + cu?.lkrRate * ec.amount;
                  }
                }
              });
            }

            // console.log(this.totalExtraChargesInLKR)
            // } else {
            //   console.log('its here');
            //   const lkr = this.currencyOptions?.find(
            //     (cu: any) => cu.currencyCode === 'LKR',
            //   );
            //   console.log(lkr);
            //   // ec.currency = lkr?._id;
            //   // ec.currencyDetails = lkr;
            //   console.log(ec);
            //   if (ec.amount) {
            //     this.totalExtraChargesInLKR =
            //       this.totalExtraChargesInLKR + lkr?.lkrRate * ec.amount;
            //   }
          }
        });
      }

      if (values.bookingCost.transferCost) {
        const cu = this.currencyOptions?.find(
          (cu: any) => cu._id === values.bookingCost.transferCurrency,
        );

        this.transferForm
          .get('bookingCost')
          .get('transferCurrencyDetails')
          .setValue(cu, {
            onlySelf: true,
            emitEvent: false,
          });
      }

      if (values.arrivalDetails.outsourcedRate) {
        const cu = this.currencyOptions?.find(
          (cu: any) => cu._id === values.arrivalDetails.outsourcedRateCurrency,
        );
        this.transferForm
          .get('arrivalDetails')
          .get('outsourcedRateCurrencyDetails')
          .setValue(cu, {
            onlySelf: true,
            emitEvent: false,
          });
      }

      if (values.departureDetails.outsourcedRate) {
        const cu = this.currencyOptions?.find(
          (cu: any) =>
            cu._id === values.departureDetails.outsourcedRateCurrency,
        );
        this.transferForm
          .get('departureDetails')
          .get('outsourcedRateCurrencyDetails')
          .setValue(cu, {
            onlySelf: true,
            emitEvent: false,
          });
      }
    });

    const departureTourDetailsGroup = this.transferForm.get(
      'tourDetails.departureTourDetails',
    );

    // Subscribe to changes in bookingCategory
    this.transferForm
      .get('bookingDetails.bookingCategory')
      .valueChanges.subscribe((bookingCategory: string) => {
        // Clear validators for arrival-related fields
        this.clearValidatorsForArrival();

        // Clear validators for departure-related fields
        this.clearValidatorsForDeparture();

        // Set validators based on the new conditions
        if (bookingCategory === 'Arrival') {
          this.setValidatorsForArrival();
        } else if (
          bookingCategory === 'Departure' ||
          this.transferForm.get('tourDetails.departureCheck').value === true
        ) {
          this.setValidatorsForDeparture();
        }

        // Update the validity of the departureTourDetails group
        departureTourDetailsGroup.updateValueAndValidity();
      });

    // Subscribe to changes in departureCheck
    this.transferForm
      .get('tourDetails.departureCheck')
      .valueChanges.subscribe((departureCheck: boolean) => {
        // Clear validators for arrival-related fields
        this.clearValidatorsForArrival();

        // Clear validators for departure-related fields
        this.clearValidatorsForDeparture();

        // Set validators based on the new conditions
        if (departureCheck) {
          this.setValidatorsForDeparture();
        } else {
          const bookingCategory = this.transferForm.get(
            'bookingDetails.bookingCategory',
          ).value;
          if (bookingCategory === 'Arrival') {
            this.setValidatorsForArrival();
          }
        }

        // Update the validity of the departureTourDetails group
        departureTourDetailsGroup.updateValueAndValidity();
      });

    // Add custom validator for 'agent' based on 'bookingType'
    this.transferForm
      .get('bookingDetails.bookingType')
      .valueChanges.subscribe((bookingType: string) => {
        const agentControl = this.transferForm.get('bookingDetails.agent');
        if (bookingType === 'Through Agent') {
          agentControl.setValidators([Validators.required]);
        } else {
          agentControl.clearValidators();
        }
        agentControl.updateValueAndValidity();
        this.transferForm.get('bookingDetails.agent').reset();

        // Repeat the same process for 'bookingReference'
        const bookingReferenceControl = this.transferForm.get(
          'bookingDetails.bookingReference',
        );
        if (bookingType === 'Through Agent') {
          bookingReferenceControl.setValidators([Validators.required]);
        } else {
          bookingReferenceControl.clearValidators();
        }
        bookingReferenceControl.updateValueAndValidity();
        this.transferForm.get('bookingDetails.bookingReference').reset();
      });

    this.transferForm
      .get('arrivalDetails.driverCategory')
      .valueChanges.subscribe((value: any) => {
        if (value === 'SR_DRIVER') {
          // Reset values to null when driverAllocationCheck is true
          this.transferForm.get('arrivalDetails.allocateDriver').setValue(null);
          this.transferForm
            .get('arrivalDetails.allocateVehicle')
            .setValue(null);
          this.transferForm.get('arrivalDetails.outsourcedRate').setValue(null);
          this.transferForm
            .get('arrivalDetails')
            .controls['allocatedVehicle'].enable();
        } else {
          this.transferForm
            .get('arrivalDetails')
            .controls['allocatedVehicle'].disable();
          this.transferForm.get('arrivalDetails.allocateDriver').setValue(null);
          this.transferForm
            .get('arrivalDetails.allocatedVehicle')
            .setValue(null);
        }
      });

    this.transferForm
      .get('departureDetails.driverCategory')
      .valueChanges.subscribe((value: any) => {
        if (value === 'SR_DRIVER') {
          // Reset values to null when driverAllocationCheck is true
          this.transferForm
            .get('departureDetails.allocateDriver')
            .setValue(null);
          this.transferForm
            .get('departureDetails.allocateVehicle')
            .setValue(null);
          this.transferForm
            .get('departureDetails.outsourcedRate')
            .setValue(null);
          this.transferForm
            .get('departureDetails')
            .controls['allocatedVehicle'].enable();
        } else {
          this.transferForm
            .get('departureDetails')
            .controls['allocatedVehicle'].disable();
          this.transferForm
            .get('departureDetails.allocateDriver')
            .setValue(null);
          this.transferForm
            .get('departureDetails.allocatedVehicle')
            .setValue(null);
        }
      });

    this.transferForm
      .get('departureDetails.allocateDriver')
      .valueChanges.subscribe((value: any) => {
        if (
          this.transferForm.get('departureDetails.driverCategory').value ===
            'OUTSOURCE_DRIVER' ||
          this.bookingData.departureDetails.driverCategory ===
            'OUTSOURCE_DRIVER'
        ) {
          this.transferForm
            .get('departureDetails.allocateVehicle')
            .setValue(null);
        }
      });

    this.transferForm
      .get('arrivalDetails.allocateDriver')
      .valueChanges.subscribe((value: any) => {
        if (
          this.transferForm.get('arrivalDetails.driverCategory').value ===
            'OUTSOURCE_DRIVER' ||
          this.bookingData.arrivalDetails.driverCategory === 'OUTSOURCE_DRIVER'
        ) {
          this.transferForm
            .get('arrivalDetails.allocateVehicle')
            .setValue(null);
        }
      });
  }

  fleetOptionChangeOnDateChange() {
    // Arrival dates and times value change function
    this.transferForm
      .get('tourDetails')
      .get('arrivalFlightDate')
      .valueChanges.subscribe(() => {
        this.checkArrivalFleetOptionChange();
      });
    this.transferForm
      .get('tourDetails')
      .get('pickUpTime')
      .valueChanges.subscribe(() => {
        this.checkArrivalFleetOptionChange();
      });
    this.transferForm
      .get('tourDetails')
      .get('arrivalEndDate')
      .valueChanges.subscribe(() => {
        this.checkArrivalFleetOptionChange();
      });
    this.transferForm
      .get('tourDetails')
      .get('arrivalEndTime')
      .valueChanges.subscribe(() => {
        this.checkArrivalFleetOptionChange();
      });
    this.transferForm
      .get('tourDetails')
      .get('vehicleCategory')
      .valueChanges.subscribe(() => {
        this.checkArrivalFleetOptionChange();
      });

    // Departure dates and times value change function
    this.transferForm
      .get('tourDetails')
      .get('departureTourDetails')
      .get('departureFlightDate')
      .valueChanges.subscribe(() => {
        this.checkDepartureFleetOptionChange();
      });
    this.transferForm
      .get('tourDetails')
      .get('departureTourDetails')
      .get('departurePickUpTime')
      .valueChanges.subscribe(() => {
        this.checkDepartureFleetOptionChange();
      });
    this.transferForm
      .get('tourDetails')
      .get('departureTourDetails')
      .get('departureEndDate')
      .valueChanges.subscribe(() => {
        this.checkDepartureFleetOptionChange();
      });
    this.transferForm
      .get('tourDetails')
      .get('departureTourDetails')
      .get('departureEndTime')
      .valueChanges.subscribe(() => {
        this.checkDepartureFleetOptionChange();
      });
    this.transferForm
      .get('tourDetails')
      .get('departureTourDetails')
      .get('departureVehicleCategory')
      .valueChanges.subscribe(() => {
        this.checkDepartureFleetOptionChange();
      });
  }
  checkArrivalFleetOptionChange() {
    if (
      this.transferForm.get('tourDetails').get('arrivalFlightDate').value &&
      this.transferForm.get('tourDetails').get('pickUpTime').value &&
      this.transferForm.get('tourDetails').get('arrivalEndDate').value &&
      this.transferForm.get('tourDetails').get('arrivalEndTime').value &&
      this.transferForm.get('tourDetails').get('vehicleCategory').value
    ) {
      const vehicleCat = this.transferForm
        .get('tourDetails')
        .get('vehicleCategory')
        .getRawValue();
      this.getVehicles(vehicleCat);
    }
  }
  checkDepartureFleetOptionChange() {
    if (
      this.transferForm
        .get('tourDetails')
        .get('departureTourDetails')
        .get('departureFlightDate').value &&
      this.transferForm
        .get('tourDetails')
        .get('departureTourDetails')
        .get('departurePickUpTime').value &&
      this.transferForm
        .get('tourDetails')
        .get('departureTourDetails')
        .get('departureEndDate').value &&
      this.transferForm
        .get('tourDetails')
        .get('departureTourDetails')
        .get('departureEndTime').value &&
      this.transferForm
        .get('tourDetails')
        .get('departureTourDetails')
        .get('departureVehicleCategory').value
    ) {
      const vehicleCat = this.transferForm
        .get('tourDetails')
        .get('departureTourDetails')
        .get('departureVehicleCategory')
        .getRawValue();
      this.getVehiclesDeparture(vehicleCat);
    }
  }

  getAndSetTempBooking(): void {
    this.loading = true;
    this.agentService
      .getAgentTempBookingById(this.tempBookingId)
      .subscribe((res: any) => {
        this.tempBooking = res;
        this.emailContent = this.tempBooking?.content;
        this.transferForm.patchValue({ ...this.tempBooking.booking });
        this.transferForm.patchValue({
          bookingDetails: {
            bookingType: 'Through Agent',
          },
        });
        this.transferForm.get('bookingDetails').get('agent').reset();
        this.transferForm.get('tourDetails').get('customer').reset();
        this.transferForm.get('tourDetails').get('vehicleCategory').reset();
        this.transferForm
          .get('tourDetails')
          .get('departureTourDetails')
          .get('departureVehicleCategory')
          .reset();
        this.loading = false;
      });
  }

  calculateTotalPassengers(): void {
    const adults = this.transferForm.get('tourDetails.noOfAdults').value || 0;
    const children =
      this.transferForm.get('tourDetails.noOfChildren').value || 0;
    const infants = this.transferForm.get('tourDetails.noOfInfants').value || 0;

    this.totalPassengers = adults + children + infants;
    this.transferForm
      .get('tourDetails.noOfPassengers')
      .setValue(this.totalPassengers);
  }

  calculateTotalPassengersDep(): void {
    const adults =
      this.transferForm.get(
        'tourDetails.departureTourDetails.departureNoOfAdults',
      ).value || 0;
    const children =
      this.transferForm.get(
        'tourDetails.departureTourDetails.departureNoOfChildren',
      ).value || 0;
    const infants =
      this.transferForm.get(
        'tourDetails.departureTourDetails.departureNoOfInfants',
      ).value || 0;

    this.totalPassengersDep = adults + children + infants;
    this.transferForm
      .get('tourDetails.departureTourDetails.departureNoOfPassengers')
      .setValue(this.totalPassengersDep);
  }

  private setValidatorsForArrival(): void {
    const arrivalFields = [
      'arrivalFlightNumber',
      'arrivalFlightTime',
      'arrivalFlightDate',
      'pickUpTime',
      'pickUpLocation',
      'dropOffLocation',
      'dropOffCity',
      'noOfPassengers',
      'noOfAdults',
      'noOfChildren',
      'noOfInfants',
      'noOfLuggages',
      'vehicleCategory',
    ];

    arrivalFields.forEach((field) => {
      this.transferForm
        .get(`tourDetails.${field}`)
        .setValidators([Validators.required]);
      this.transferForm.get(`tourDetails.${field}`).updateValueAndValidity();
    });
  }

  private clearValidatorsForArrival(): void {
    const arrivalFields = [
      'arrivalFlightNumber',
      'arrivalFlightTime',
      'arrivalFlightDate',
      'pickUpTime',
      'pickUpLocation',
      'dropOffLocation',
      'dropOffCity',
      'noOfPassengers',
      'noOfAdults',
      'noOfChildren',
      'noOfInfants',
      'noOfLuggages',
      'vehicleCategory',
      'distanceToDestination',
    ];

    arrivalFields.forEach((field) => {
      this.transferForm.get(`tourDetails.${field}`).clearValidators();
      this.transferForm.get(`tourDetails.${field}`).updateValueAndValidity();
    });
  }

  private setValidatorsForDeparture(): void {
    const departureFields = [
      'departureFlightNumber',
      'departureFlightTime',
      'departureFlightDate',
      'departurePickUpTime',
      'departurePickUpLocation',
      'departureDropOffLocation',
      'departureDropOffCity',
      'departureNoOfPassengers',
      'departureNoOfAdults',
      'departureNoOfChildren',
      'departureNoOfInfants',
      'departureNoOfLuggages',
      'departureVehicleCategory',
    ];

    departureFields.forEach((field) => {
      this.transferForm
        .get(`tourDetails.departureTourDetails.${field}`)
        .setValidators([Validators.required]);
      this.transferForm
        .get(`tourDetails.departureTourDetails.${field}`)
        .updateValueAndValidity();
    });
  }

  private clearValidatorsForDeparture(): void {
    const departureFields = [
      'departureFlightNumber',
      'departureFlightTime',
      'departureFlightDate',
      'departurePickUpTime',
      'departurePickUpLocation',
      'departureDropOffLocation',
      'departureDropOffCity',
      'departureNoOfPassengers',
      'departureNoOfAdults',
      'departureNoOfChildren',
      'departureNoOfInfants',
      'departureNoOfLuggages',
      'departureVehicleCategory',
      'departureDistanceToDestination',
    ];

    departureFields.forEach((field) => {
      this.transferForm
        .get(`tourDetails.departureTourDetails.${field}`)
        .clearValidators();
      this.transferForm
        .get(`tourDetails.departureTourDetails.${field}`)
        .updateValueAndValidity();
    });
  }

  setBreadcrumbs(): void {
    if (!this.reservationId) {
      this.breadcrumbs = [
        {
          title: 'Bookings',
          icon: 'car',
          route: '/admin/booking-transfer',
        },
        {
          title: 'Add Transfer Booking',
        },
      ];
    } else {
      this.breadcrumbs = [
        {
          title: 'Bookings',
          icon: 'car',
          route: '/admin/booking-transfer',
        },
        {
          title: 'Edit Transfer Booking',
        },
      ];
    }
  }

  addDeductionItem(input: any): void {
    const value = input.value;
    if (this.deductionOptions.indexOf(value) === -1) {
      this.deductionOptions = [
        ...this.deductionOptions,
        input.value || `New item ${this.dIndex++}`,
      ];
    }
  }

  createDeduction(): FormGroup {
    return this.fb.group({
      chargeType: ['', []],
      amount: [0, []],
      currency: ['LKR', []],
      currencyDetails: [null, []],
    });
  }

  public get deductions(): FormArray {
    return this.transferForm.get('bookingCost').get('deductions') as FormArray;
  }

  deleteDeductions(index: any): void {
    this.deductions.removeAt(index);
    this.deductionCurrencies.splice(index, 1);
  }

  addDeduction(): void {
    this.deductions.push(this.createDeduction());
  }

  bookingCancel() {
    if (this.prevPage) {
      this.router.navigate([`admin/booking-transfer/${this.bookingData._id}`]);
    } else {
      this.router.navigate(['/admin/booking-transfer']);
    }
  }

  getCurrencyOptions(): void {
    this.currencyService.getAllActiveCurrencies().subscribe((res: any) => {
      this.currencyOptions = res;
      this.defaultLKR = res.find((cur: any) => cur.currencyCode === 'LKR');
      // const lkr = res?.find((cu: any) => cu.currencyCode === 'LKR');
      // this.rentBookingForm.patchValue({
      //   tourDetails: {
      //     costPerExtraMileageCurrency: lkr?._id,
      //     costPerExtraMileageCurrencyDetails: lkr,
      //   },
      //   allocationDetails: {
      //     outsourcedRateCurrency: lkr?._id,
      //     outsourcedRateCurrencyDetails: lkr,
      //   },
      //   bookingCostInformation: {
      //     depositCurrency: lkr?._id,
      //     depositCurrencyDetails: lkr,
      //     totalRentalAmountCurrency: lkr?._id,
      //     totalRentalAmountCurrencyDetails: lkr,
      //     prepaidAmountCurrency: lkr?._id,
      //     prepaidAmountCurrencyDetails: lkr,
      //     rentalAmountDueCurrency: lkr?._id,
      //     rentalAmountDueCurrencyDetails: lkr,
      //
      //   }
      //
      // })
    });
  }

  cancel(): void {}

  onSubmit(): void {
    if (this.transferForm.get('arrivalDetails.allocateVehicle').value) {
      this.transferForm
        .get('arrivalDetails.arrivalSupplier')
        .patchValue(this.arrivalSupplier);
    } else {
      this.transferForm.get('arrivalDetails.arrivalSupplier').patchValue(null);
    }

    if (this.transferForm.get('departureDetails.allocateVehicle').value) {
      this.transferForm
        .get('departureDetails.departureSupplier')
        .patchValue(this.departureSupplier);
    } else {
      this.transferForm
        .get('departureDetails.departureSupplier')
        .patchValue(null);
    }

    let formData = this.transferForm.getRawValue();

    if (this.reservationId) {
      if (formData?.bookingCost?.extraCharges?.length > 0) {
        this.totalExtraChargesInLKR = 0;
        formData?.bookingCost?.extraCharges?.forEach((ec: any) => {
          if (ec.currency) {
            const cu = this.currencyOptions?.find(
              (cu: any) => cu._id === ec.currency,
            );
            ec.currencyDetails = cu;
          }
        });
      }
      if (formData.bookingCost.transferCost) {
        const cu = this.currencyOptions?.find(
          (cu: any) => cu._id === formData.bookingCost.transferCurrency,
        );
        formData.bookingCost.transferCurrencyDetails = cu;
      }

      if (this.transferForm.get('arrivalDetails.status').value === 'NONE') {
        this.transferForm.get('arrivalDetails.status').setValue('RESERVATION');
      } else if (
        this.transferForm.get('departureDetails.status').value === 'NONE'
      ) {
        this.transferForm
          .get('departureDetails.status')
          .setValue('RESERVATION');
      }
      this.transferForm.get('tourDetails.customer').enable();
      this.transferService
        .updateBooking({
          _id: this.reservationId,
          ...this.transferForm.value,
        })
        .then(() => {
          if (this.prevPage) {
            this.submit = true;
            this.router.navigate([
              `/admin/booking-transfer/${this.reservationId}`,
            ]);
          } else {
            this.submit = true;
            this.router.navigate(['/admin/booking-transfer']);
          }
        });
    } else if (this.transferForm.valid) {
      if (
        this.transferForm.get('bookingDetails.bookingCategory').value ===
          'Arrival' &&
        !this.transferForm.get('tourDetails.departureCheck').value
      ) {
        this.transferForm.patchValue({
          arrivalDetails: {
            status: 'RESERVATION',
          },
        });
      } else if (
        this.transferForm.get('bookingDetails.bookingCategory').value ===
          'Arrival' &&
        this.transferForm.get('tourDetails.departureCheck').value
      ) {
        this.transferForm.patchValue({
          arrivalDetails: {
            status: 'RESERVATION',
          },
          departureDetails: {
            status: 'RESERVATION',
          },
        });
      } else if (
        this.transferForm.get('bookingDetails.bookingCategory').value ===
        'Departure'
      ) {
        this.transferForm.patchValue({
          departureDetails: {
            status: 'RESERVATION',
          },
        });
      }
      formData = this.transferForm.getRawValue();
      if (formData?.bookingCost?.extraCharges?.length > 0) {
        this.totalExtraChargesInLKR = 0;
        formData?.bookingCost?.extraCharges?.forEach((ec: any) => {
          if (ec.currency) {
            const cu = this.currencyOptions?.find(
              (cu: any) => cu._id === ec.currency,
            );
            ec.currencyDetails = cu;
          }
        });
      }
      if (formData.bookingCost.transferCost) {
        const cu = this.currencyOptions?.find(
          (cu: any) => cu._id === formData.bookingCost.transferCurrency,
        );
        formData.bookingCost.transferCurrencyDetails = cu;
      }
      this.transferService
        .createTransferReservation({
          ...formData,
          tempBooking: this.tempBookingId ? this.tempBookingId : undefined,
        })
        .subscribe(() => {
          this.message.create(
            'success',
            'New Transfer Reservation has been added!',
          );
          this.submit = true;
          this.router.navigate(['/admin/booking-transfer']);
        },
        (e: any) => {
          const errorMessage = e.error?.message || 'An error occurred';
          this.message.create('error', errorMessage);
        },
      );
    } else {
      this.markFormGroupAsTouched(this.transferForm);
    }
  }

  markFormGroupAsTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach((control: any) => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupAsTouched(control);
      }
    });
  }

  showAddAgentPopup(): void {
    this.visibleAddAgentPopup = true;
  }

  showAddCustomerPopup(): void {
    this.visibleAddCustomerPopup = true;
  }

  showAddDriverPopup(): void {
    this.driverService.initAddDriverPopupForm.next(true);
    this.visibleAddDriverPopup = true;
  }

  showAddVehiclePopup(): void {
    this.driverService.supplierVehicleFormType.next('add');
    this.visibleAddVehiclePopup = true;
  }

  onGetAddAgentChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddAgentPopup = false;
        break;
      case 'created':
        this.message.create('success', 'New Agent has been added!');
        this.getAgentOptions();
        this.visibleAddAgentPopup = false;
        break;
    }
  }

  onGetAddCustomerChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddCustomerPopup = false;
        break;
      case 'created':
        this.message.create('success', 'New Customer has been added!');
        this.getCustomerOptions();
        this.visibleAddCustomerPopup = false;
        break;
    }
  }

  onGetAddDriverChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddDriverPopup = false;
        break;
      case 'created':
        this.message.create('success', 'New Driver has been added!');
        this.getDriverOptions();
        this.getDriverOptionsDep();
        this.visibleAddDriverPopup = false;
        break;
    }
  }

  onGetAddVehicleChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddVehiclePopup = false;
        break;
      case 'submit':
        this.getSupplierVehiclesArrival(
          this.transferForm.get('arrivalDetails.allocateDriver').value,
        );
        this.getSupplierVehiclesDeparture(
          this.transferForm.get('departureDetails.allocateDriver').value,
        );
        this.visibleAddVehiclePopup = false;
        break;
    }
  }

  createAExtraCharges(): FormGroup {
    return this.fb.group({
      chargeType: ['', []],
      amount: [0, []],
      currency: ['65961e65cad7ae7c000623ff', []],
      currencyDetails: [null, []],
      description: ['', []],
    });
  }

  public get extraCharges(): FormArray {
    return this.transferForm
      .get('bookingCost')
      .get('extraCharges') as FormArray;
  }

  deleteExtraCharges(index: any): void {
    this.extraCharges.removeAt(index);
    this.extraChargesCurrencies.splice(index, 1);
  }

  addExtraCharge(): void {
    this.extraCharges.push(this.createAExtraCharges());
  }

  addItem(input: any): void {
    const value = input.value;
    if (this.chargesOptions.indexOf(value) === -1) {
      this.chargesOptions = [
        ...this.chargesOptions,
        input.value || `New item ${this.index++}`,
      ];
    }
  }

  getTotalAmount(): number {
    const extraCharges = this.transferForm.get(
      'bookingCost.extraCharges',
    ) as FormArray;
    let total = 0;

    extraCharges.controls.forEach((control: AbstractControl) => {
      if (control instanceof FormGroup) {
        const amountControl = control.get('amount');
        if (amountControl && amountControl.value !== null) {
          const amount = amountControl.value as number;
          total += amount;
        }
      }
    });

    const transferRate =
      this.transferForm.get('bookingCost.transferRate').value || 0;
    return total * transferRate;
  }

  async getVehicleCategory(): Promise<void> {
    this.vehicleCategories = await this.fleetService.getAllVehicleCat();
    this.vehicleCategoriesArrivalFiltered = this.vehicleCategories;
    this.vehicleCategoriesDepFiltered = this.vehicleCategories;
  }

  getAgentOptions(): void {
    this.agentService.getAllTransferAgents().subscribe((res: any) => {
      this.agentOptions = res;
      this.agentOptionsFiler = res;
    });
  }

  getCustomerOptions(): void {
    this.customerService.getAllActiveCustomers().subscribe(
      (res: any) => {
        this.customerOptions = res;
        this.customerOptionsFilter = res;
      },
      (e: any) => {
        this.message.create('error', 'Error');
      },
    );
  }

  getDriverOptions(event?: any): void {
    const payload = {
      driverSegment: event,
      startDate: AppUtils.mergeDateAndTime(
        this.transferForm.get('tourDetails').get('arrivalFlightDate').value,
        this.transferForm.get('tourDetails').get('pickUpTime').value,
      ),
      endDate: AppUtils.mergeDateAndTime(
        this.transferForm.get('tourDetails').get('arrivalEndDate').value,
        this.transferForm.get('tourDetails').get('arrivalEndTime').value,
      ),
      addEditBooking: true,
      ...this.arrivalDatesAndIdSetForFleetOption(),
    };
    this.driversFetching = true;
    this.driverService.getDriverOptions(payload).subscribe((res: any) => {
      this.driversFetching = false;
      this.driverOptions = res;
      this.driverOptionsFiltered = res;
    });
  }

  getDriverOptionsDep(event?: any): void {
    const payload = {
      driverSegment: event,
      startDate: AppUtils.mergeDateAndTime(
        this.transferForm
          .get('tourDetails')
          .get('departureTourDetails')
          .get('departureFlightDate').value,
        this.transferForm
          .get('tourDetails')
          .get('departureTourDetails')
          .get('departurePickUpTime').value,
      ),
      endDate: AppUtils.mergeDateAndTime(
        this.transferForm
          .get('tourDetails')
          .get('departureTourDetails')
          .get('departureEndDate').value,
        this.transferForm
          .get('tourDetails')
          .get('departureTourDetails')
          .get('departureEndTime').value,
      ),
      addEditBooking: true,
      ...this.arrivalDatesAndIdSetForFleetOption(),
    };
    this.driversFetchingDep = true;
    this.driverService.getDriverOptions(payload).subscribe((res: any) => {
      this.driversFetchingDep = false;
      this.driverOptionsDep = res;
      this.driverOptionsDepFiltered = res;
    });
  }

  getVehicles(event: any): void {
    this.fleetsOptions = [];
    this.transferForm
      .get('arrivalDetails')
      .get('allocatedVehicle')
      .setValue(null, {
        onlySelf: true,
        emitEvent: false,
      });
    this.fleetsFetching = true;
    this.fleetService
      .getFleetsAsOptions({
        category: event,
        addEditBooking: true,
        ...this.arrivalDatesAndIdSetForFleetOption(),
      })
      .then((res: any) => {
        this.fleetsFetching = false;
        this.fleetsOptions = res;
        this.fleetsOptionsFiltered = res;
      });
  }
  arrivalDatesAndIdSetForFleetOption() {
    const tourStartDate = this.transferForm
      .get('tourDetails')
      .get('arrivalDateAndTime')
      .getRawValue();
    let tourEndDate;

    const arrivalEndDate = this.transferForm
      .get('tourDetails')
      .get('arrivalEndDate')
      .getRawValue();
    const arrivalEndTime = this.transferForm
      .get('tourDetails')
      .get('arrivalEndTime')
      .getRawValue();
    if (arrivalEndDate && arrivalEndTime) {
      tourEndDate = new Date(arrivalEndDate);
      const endTime = new Date(arrivalEndTime);
      tourEndDate = new Date(tourEndDate.setHours(endTime.getHours()));
      tourEndDate = new Date(tourEndDate.setMinutes(endTime.getMinutes()));
      tourEndDate = new Date(tourEndDate.setSeconds(endTime.getSeconds()));
    }
    if (tourStartDate && tourEndDate) {
      return {
        tourStartDate,
        tourEndDate,
        bookingId: this.reservationId ? this.reservationId : null,
      };
    }
    return {};
  }

  getVehiclesDeparture(event: any): void {
    this.fleetsOptions = [];
    this.transferForm
      .get('departureDetails')
      .get('allocatedVehicle')
      .setValue(null, {
        onlySelf: true,
        emitEvent: false,
      });
    this.fleetsFetchingDep = true;
    this.fleetService
      .getFleetsAsOptions({
        category: event,
        addEditBooking: true,
        ...this.departureDatesAndIdSetForFleetOption(),
      })
      .then((res: any) => {
        this.fleetsFetchingDep = false;
        this.fleetsOptionsDeparture = res;
        this.fleetsOptionsDepartureFiltered = res;
      });
  }
  departureDatesAndIdSetForFleetOption() {
    const tourStartDate = this.transferForm
      .get('tourDetails')
      .get('departureTourDetails')
      .get('departureDateAndTime')
      .getRawValue();
    let tourEndDate;

    const departureEndDate = this.transferForm
      .get('tourDetails')
      .get('departureTourDetails')
      .get('departureEndDate')
      .getRawValue();
    const departureEndTime = this.transferForm
      .get('tourDetails')
      .get('departureTourDetails')
      .get('departureEndTime')
      .getRawValue();
    if (departureEndDate && departureEndTime) {
      tourEndDate = new Date(departureEndDate);
      const endTime = new Date(departureEndTime);
      tourEndDate = new Date(tourEndDate.setHours(endTime.getHours()));
      tourEndDate = new Date(tourEndDate.setMinutes(endTime.getMinutes()));
      tourEndDate = new Date(tourEndDate.setSeconds(endTime.getSeconds()));
    }
    if (tourStartDate && tourEndDate) {
      return {
        tourStartDate,
        tourEndDate,
        bookingId: this.reservationId ? this.reservationId : null,
      };
    }
    return {};
  }

  getSupplierVehiclesArrival(event: any): void {
    if (
      this.transferForm.get('arrivalDetails').get('driverCategory').value ===
        'OUTSOURCE_DRIVER' ||
      this.bookingData?.arrivalDetails?.driverCategory === 'OUTSOURCE_DRIVER'
    ) {
      if (
        this.transferForm.get('arrivalDetails').get('allocateDriver').value !==
        null
      ) {
        this.supplierVehiclesFetching = true;
        this.driverService
          .getSupplierVehiclesByDriver(event)
          .subscribe((res: any) => {
            this.supplierVehiclesFetching = false;
            if (this.reservationId) {
              this.getSupplierVehicle(
                this.bookingData?.arrivalDetails?.allocateVehicle,
              );
            }
            this.supplierVehicleOptionsArrival = res?.supplierVehicles;
            this.supplierVehicleOptionsArrivalFiltered =
              this.supplierVehicleOptionsArrival;
            this.arrivalSupplier = res.supplierId;
            // }
          });
      }
    }
  }

  getSupplierVehiclesDeparture(event: any): void {
    if (
      this.transferForm.get('departureDetails').get('driverCategory').value ===
        'OUTSOURCE_DRIVER' ||
      this.bookingData?.departureDetails?.driverCategory === 'OUTSOURCE_DRIVER'
    ) {
      if (
        this.transferForm.get('departureDetails').get('allocateDriver')
          .value !== null
      ) {
        this.supplierVehiclesFetchingDep = true;
        this.driverService
          .getSupplierVehiclesByDriver(event)
          .subscribe((res: any) => {
            this.supplierVehiclesFetchingDep = false;
            this.supplierVehicleOptionsDeparture = res?.supplierVehicles;
            this.supplierVehicleOptionsDepartureFiltered =
              this.supplierVehicleOptionsDeparture;
            if (this.reservationId) {
              this.getSupplierVehicleDep(
                this.bookingData?.departureDetails?.allocateVehicle,
              );
            }
            this.departureSupplier = res.supplierId;
            // }
          });
      }
    }
  }

  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.submit) {
      return true;
    } else if (this.transferForm.dirty || this.transferForm.touched) {
      return confirm(
        ' You have unsaved changes, Do you really want to discard these changes?',
      );
    } else {
      return true;
    }
  }

  bookingCostInfoUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_TRANSFER_BOOKING_COST_INFO_UPLOAD)
      .subscribe((res) => {
        this.message.create('success', `Attachment has been uploaded!`);
        const data = res as any;
        this.bookingCostInfoUploadFiles.push({
          name: item.file.name,
          url: data.url,
        });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_TRANSFER_BOOKING_COST_INFO_UPLOAD,
          loading: false,
        });
      });

  removeUploadFile(index: any, field: string): void {
    switch (field) {
      case 'booking-cost-info':
        this.bookingCostInfoUploadFiles.splice(index, 1);
        break;
    }
    this.message.create('success', `Attachment has been deleted!`);
  }

  getFleetVehicle(event: any) {
    this.arrivalVehicle = {
      image: 'assets/img/image-placeholder.png',
      registrationNo: '-',
      mileage: 0,
      fuel: 0,
      seats: 0,
      model: '',
    };
    if (event) {
      this.fleetService.getOneFleetById(event).then((res) => {
        if (res.generalInformation?.vehicleImg[0]) {
          this.arrivalVehicle.image = res.generalInformation?.vehicleImg[0];
        }
        this.arrivalVehicle.seats = res.vehicleDetails?.seatsNumber;
        this.arrivalVehicle.registrationNo =
          res.vehicleDetails?.registrationNumber;
      });
    }
  }
  getVehicleAvailabilityIcon(status: string) {
    return this.availabilityStatusPairs.find((st) => st.value === status);
  }
  getDriverAvailabilityIcon(status: string) {
    return this.driverAvailabilityStatus.find((st) => st.value === status);
  }

  getFleetVehicleDep(event: any) {
    this.depVehicle = {
      image: 'assets/img/image-placeholder.png',
      registrationNo: '-',
      mileage: 0,
      fuel: 0,
      seats: 0,
      model: '',
    };
    if (event) {
      this.fleetService.getOneFleetById(event).then((res) => {
        if (res.generalInformation?.vehicleImg[0]) {
          this.depVehicle.image = res.generalInformation?.vehicleImg[0];
        }
        this.depVehicle.seats = res.vehicleDetails?.seatsNumber;
        this.depVehicle.registrationNo = res.vehicleDetails?.registrationNumber;
      });
    }
  }

  getSupplierVehicle(event: any) {
    this.arrivalVehicle = {
      image: 'assets/img/image-placeholder.png',
      registrationNo: '-',
      mileage: 0,
      fuel: 0,
      seats: 0,
      model: '',
    };
    const foundVehicle = this.supplierVehicleOptionsArrival.find(
      (vehicle) => vehicle._id === event,
    );
    if (foundVehicle) {
      if (foundVehicle.vehicleImages[0]?.attach?.url) {
        this.arrivalVehicle.image = foundVehicle.vehicleImages[0]?.attach?.url;
      }
      this.arrivalVehicle.registrationNo = foundVehicle.registerNumber;
      this.arrivalVehicle.model = foundVehicle.vehicleModel;
    } else {
      console.log('Vehicle not found');
    }
  }

  getSupplierVehicleDep(event: any) {
    this.depVehicle = {
      image: 'assets/img/image-placeholder.png',
      registrationNo: '-',
      mileage: 0,
      fuel: 0,
      seats: 0,
      model: '',
    };
    const foundVehicle = this.supplierVehicleOptionsDeparture.find(
      (vehicle) => vehicle._id === event,
    );
    if (foundVehicle) {
      if (foundVehicle.vehicleImages[0]?.attach?.url) {
        this.depVehicle.image = foundVehicle.vehicleImages[0]?.attach?.url;
      }
      this.depVehicle.registrationNo = foundVehicle.registerNumber;
      this.depVehicle.model = foundVehicle.vehicleModel;
    } else {
      console.log('Vehicle not found');
    }
  }

  getDriver(event: any) {
    this.arrivalDriver = {
      name: '-',
      mobileNo: '-',
      supplier: '-',
    };
    this.driverService.getOneDriverById(event).then((res) => {
      if (res.supplier) {
        this.selectedSupplierId = res.supplier;
        this.supplierService.getSuppliersById(res.supplier).then((supplier) => {
          this.arrivalDriver.mobileNo = res.mobileNumber;
          this.arrivalDriver.name = res.fullName;
          this.arrivalDriver.supplier = supplier.supplierDetails?.name;
        });
      } else {
        this.arrivalDriver.mobileNo = res.mobileNumber;
        this.arrivalDriver.name = res.fullName;
      }
    });
  }

  getDriverDep(event: any) {
    this.depDriver = {
      name: '-',
      mobileNo: '-',
      supplier: '-',
    };
    this.driverService.getOneDriverById(event).then((res) => {
      if (res.supplier) {
        this.selectedSupplierId = res.supplier;
        this.supplierService.getSuppliersById(res.supplier).then((supplier) => {
          this.depDriver.mobileNo = res.mobileNumber;
          this.depDriver.name = res.fullName;
          this.depDriver.supplier = supplier.supplierDetails?.name;
        });
      } else {
        this.depDriver.mobileNo = res.mobileNumber;
        this.depDriver.name = res.fullName;
      }
    });
  }

  onSearchCategory(searchValue: string): void {
    if (searchValue) {
      // Filter the available vehicles based on the search value
      this.vehicleCategoriesArrivalFiltered = this.vehicleCategories.filter(
        (category: { name: string; _id: string }) =>
          category.name.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all available vehicles
      this.vehicleCategoriesArrivalFiltered = this.vehicleCategories;
    }
  }

  onSearchDepCategory(searchValue: string): void {
    if (searchValue) {
      // Filter the available vehicles based on the search value
      this.vehicleCategoriesDepFiltered = this.vehicleCategories.filter(
        (category: { name: string; _id: string }) =>
          category.name.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all available vehicles
      this.vehicleCategoriesDepFiltered = this.vehicleCategories;
    }
  }

  onSearchAllocatedVehicle(searchValue: string): void {
    if (searchValue) {
      // Filter the available vehicles based on the search value
      this.fleetsOptionsFiltered = this.fleetsOptions.filter((vehicle) =>
        vehicle.vehicleName.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all available vehicles
      this.fleetsOptionsFiltered = this.fleetsOptions;
    }
  }

  onSearchSupplierVehicle(searchValue: string): void {
    if (searchValue) {
      // Filter the supplier vehicles based on the search value
      this.supplierVehicleOptionsArrivalFiltered =
        this.supplierVehicleOptionsArrival.filter(
          (option: {
            _id: string;
            registerNumber: string;
            vehicleModel: string;
          }) =>
            option.registerNumber
              .toLowerCase()
              .includes(searchValue.toLowerCase()) ||
            option.vehicleModel
              .toLowerCase()
              .includes(searchValue.toLowerCase()),
        );
    } else {
      // If the search value is empty, show all supplier vehicles
      this.supplierVehicleOptionsArrivalFiltered =
        this.supplierVehicleOptionsArrival;
    }
  }

  onSearchAllocatedVehicleDep(searchValue: string): void {
    if (searchValue) {
      // Filter the available vehicles based on the search value
      this.fleetsOptionsDepartureFiltered = this.fleetsOptionsDeparture.filter(
        (vehicle) =>
          vehicle.vehicleName.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all available vehicles
      this.fleetsOptionsDepartureFiltered = this.fleetsOptionsDeparture;
    }
  }

  onSearchSupplierVehicleDep(searchValue: string): void {
    if (searchValue) {
      // Filter the supplier vehicles based on the search value
      this.supplierVehicleOptionsDepartureFiltered =
        this.supplierVehicleOptionsDeparture.filter(
          (option: {
            _id: string;
            registerNumber: string;
            vehicleModel: string;
          }) =>
            option.registerNumber
              .toLowerCase()
              .includes(searchValue.toLowerCase()) ||
            option.vehicleModel
              .toLowerCase()
              .includes(searchValue.toLowerCase()),
        );
    } else {
      // If the search value is empty, show all supplier vehicles
      this.supplierVehicleOptionsDepartureFiltered =
        this.supplierVehicleOptionsDeparture;
    }
  }

  onSearchDriverDep(searchValue: string): void {
    if (searchValue) {
      // Filter the available vehicles based on the search value
      this.driverOptionsDepFiltered = this.driverOptionsDep.filter((driver) =>
        driver.fullName.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all available vehicles
      this.driverOptionsDepFiltered = this.driverOptionsDep;
    }
  }

  onSearchDriver(searchValue: string): void {
    if (searchValue) {
      // Filter the available vehicles based on the search value
      this.driverOptionsFiltered = this.driverOptions.filter((driver) =>
        driver.fullName.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all available vehicles
      this.driverOptionsFiltered = this.driverOptions;
    }
  }

  onSearchAgent(searchValue: string): void {
    if (searchValue) {
      // Filter the available vehicles based on the search value
      this.agentOptionsFiler = this.agentOptions.filter((agent) =>
        agent.name.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all available vehicles
      this.agentOptionsFiler = this.agentOptions;
    }
  }

  onSearchCustomer(searchValue: string): void {
    if (searchValue) {
      // Filter the available vehicles based on the search value
      this.customerOptionsFilter = this.customerOptions.filter((customer) =>
        customer.name.toLowerCase().includes(searchValue.toLowerCase()),
      );
    } else {
      // If the search value is empty, show all available vehicles
      this.customerOptionsFilter = this.customerOptions;
    }
  }
  openEmailContentDrawer(): void {
    if (this.emailContent) {
      const drawerRef = this.drawerService.create({
        nzWidth: '40%',
        nzContent: EmailContentDrawerComponent,
        nzContentParams: {
          content: this.emailContent,
        },
      });
    }
  }
  disableArrivalSelectedVehicle(vehicleId: string) {
    return this.bookingData?.arrivalDetails?.allocatedVehicle?._id &&
      this.transferForm?.get('arrivalDetails')?.get('allocatedVehicle')?.value
      ? this.bookingData.arrivalDetails.allocatedVehicle?._id.toString() ===
          vehicleId.toString()
      : false;
  }
  disableDepartureSelectedVehicle(vehicleId: string) {
    return this.bookingData?.departureDetails?.allocatedVehicle?._id &&
      this.transferForm?.get('departureDetails')?.get('allocatedVehicle')?.value
      ? this.bookingData.departureDetails.allocatedVehicle?._id.toString() ===
          vehicleId.toString()
      : false;
  }

  refreshVehicles() {
    const bookingCategory = this.transferForm.get(
      'bookingDetails.bookingCategory',
    ).value;
    const vehicleCategory = this.transferForm.get(
      'tourDetails.vehicleCategory',
    ).value;
    const departureVehicleCategory = this.transferForm.get(
      'tourDetails.departureTourDetails.departureVehicleCategory',
    ).value;

    console.log('Refresh Vehicles - Booking Category:', bookingCategory);
    console.log('Vehicle Category:', vehicleCategory);
    console.log('Departure Vehicle Category:', departureVehicleCategory);

    if (bookingCategory === 'Arrival') {
      console.log('Refreshing Arrival Vehicles');
      this.supplierVehicleOptionsArrival = [];
      this.supplierVehicleOptionsArrivalFiltered = [];
      this.getVehicles(vehicleCategory);
    } else if (bookingCategory === 'Departure') {
      console.log('Refreshing Departure Vehicles');
      this.supplierVehicleOptionsDeparture = [];
      this.supplierVehicleOptionsDepartureFiltered = [];
      this.getVehiclesDeparture(departureVehicleCategory);
    } else {
      console.log('Refreshing');
      this.supplierVehicleOptionsArrival = [];
      this.supplierVehicleOptionsDeparture = [];
      this.supplierVehicleOptionsArrivalFiltered = [];
      this.supplierVehicleOptionsDepartureFiltered = [];
      this.getVehicles(vehicleCategory);
      this.getVehiclesDeparture(departureVehicleCategory);
    }
  }

  refreshDrivers() {
    const bookingCategory = this.transferForm.get(
      'bookingDetails.bookingCategory',
    ).value;
    const arrivalDriverCategory = this.transferForm.get('arrivalDetails.driverCategory').value;
    const departureDriverCategory = this.transferForm.get('departureDetails.driverCategory').value;


    if (bookingCategory === 'Arrival') {
      console.log('Refreshing Arrival Drivers');
      this.driverOptions = [];
      this.getDriverOptions(arrivalDriverCategory);
    } else if (bookingCategory === 'Departure') {
      console.log('Refreshing Departure Drivers');
      this.driverOptionsDep = [];
      this.getDriverOptionsDep(departureDriverCategory);
    } else {
      console.log('Refreshing');
      this.driverOptions = [];
      this.driverOptionsDep = [];
      this.getDriverOptions();
      this.getDriverOptionsDep();
    }
  }
}
